// extracted by mini-css-extract-plugin
module.exports = {"root":"BaseFilterBar_root__1L_U9","withBackAction":"BaseFilterBar_withBackAction__1IK0l","content":"BaseFilterBar_content__1NuD6","backButton":"BaseFilterBar_backButton__1PLfo"};